{
    "appHint": "main",
    "apps": {
        "main": {
            "name": "Solomon",
            "shortName": "App",
            "version": "1.0.0",
            "environments": {
                "Development": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "apiUrls": {
                            "solomonData": "https://data-dev.solomonlabs.io",
                            "yaas": "https://yaas-dev.solomonlabs.io",
                            "yaasMetrics": "https://yaas.solomonlabs.io",
                            "rewards": "https://rewards-dev.solomonlabs.io/api"
                        },
                        "verificationWallet": "EAbdqx7EK7qJoDVJwyRocRAU1oKm4PXtBRqZBW51k7HJ"
                    },
                    "environment": "Development"
                },
                "Staging": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "apiUrls": {
                            "solomonData": "https://data-dev.solomonlabs.io",
                            "yaas": "https://yaas-dev.solomonlabs.io",
                            "yaasMetrics": "https://yaas.solomonlabs.io",
                            "rewards": "https://rewards-dev.solomonlabs.io/api"
                        },
                        "verificationWallet": "EAbdqx7EK7qJoDVJwyRocRAU1oKm4PXtBRqZBW51k7HJ"
                    },
                    "environment": "Staging"
                },
                "Production": {
                    "config": {
                        "rpcEndpoint": "https://chloe-w2qjqk-fast-mainnet.helius-rpc.com",
                        "network": "mainnet-beta",
                        "apiUrls": {
                            "solomonData": "https://data.solomonlabs.io",
                            "yaas": "https://yaas.solomonlabs.io",
                            "yaasMetrics": "https://yaas.solomonlabs.io",
                            "rewards": "https://rewards.solomonlabs.io/api"
                        },
                        "verificationWallet": "EAbdqx7EK7qJoDVJwyRocRAU1oKm4PXtBRqZBW51k7HJ"
                    },
                    "environment": "Production"
                }
            }
        }
    }
}
